module.exports = __webpack_public_path__ + "img/Newbie_Staff_02_Mage.1215b1fe.png";